import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { Icon } from "../../components/Component";
import Logo from "../logo/Logo";
import Menu, { MenuItem } from "../menu/Menu";
import menu from "../menu/MenuData";
import settingMenu from "../menu/SettingData";
import Toggle from "./Toggle";

const Sidebar = ({ fixed, theme, className, sidebarToggle, mobileView, ...props }) => {
  const location = useLocation();
  const [collapseSidebar, setSidebar] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);

  const toggleCollapse = () => {
    setSidebar(!collapseSidebar);
  };

  const handleMouseEnter = () => setMouseEnter(true);
  const handleMouseLeave = () => setMouseEnter(false);

  const classes = classNames({
    "nk-sidebar": true,
    "nk-sidebar-fixed": fixed,
    "is-compact": collapseSidebar,
    "has-hover": collapseSidebar && mouseEnter,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
    [`${className}`]: className,
  });

  return (
    <div className={classes}>
      <div className="nk-sidebar-element nk-sidebar-head">
        <div className="nk-menu-trigger">
          <Toggle className="nk-nav-toggle nk-quick-nav-icon d-xl-none mr-n2" icon="arrow-left" click={sidebarToggle} />
          <Toggle
            className={`nk-nav-compact nk-quick-nav-icon d-none d-xl-inline-flex ${
              collapseSidebar ? "compact-active" : ""
            }`}
            click={toggleCollapse}
            icon="menu"
          />
        </div>
        <div className="nk-sidebar-brand">
          <Logo />
        </div>
      </div>
      <div className="nk-sidebar-content" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {location?.pathname?.includes("/settings") ? (
          <SimpleBar className="nk-sidebar-menu sidebarMenu">
            <Menu sidebarToggle={sidebarToggle} menu={settingMenu} mobileView={mobileView} />
            <ul className="nk-menu sidebarSettings">
              <MenuItem link={"/"} text={"Back"} icon={"arrow-long-left"} />
            </ul>
          </SimpleBar>
        ) : (
          <SimpleBar className="nk-sidebar-menu sidebarMenu">
            <Menu sidebarToggle={sidebarToggle} menu={menu} mobileView={mobileView} />
          </SimpleBar>
        )}
      </div>
    </div>
  );
};
export default Sidebar;
